import type { ReactNode } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { appTheme } from "theme";

export function ThemeProvider({ children }: { children: ReactNode }) {
  return <ChakraProvider theme={appTheme}>{children}</ChakraProvider>;
}
